import Constants from '../../globals/Constants';
import {fabric} from 'fabric-webpack';

const addedDrawing = (event: any): void => {
   const drawing = event.target;

   if (!drawing.canvas.isDrawingMode) {
      return;
   }

   drawing.hasControls = false;
   drawing.padding = Constants.annotation.controlsPadding;
   drawing.shapeType = Constants.annotation.type.freehand;
   drawing.fill = 'transparent';
   drawing.perPixelTargetFind = true;
   drawing.targetFindTolerance = 10;
};

const startDrawing = (canvas: any, color: string): void => {
   canvas.deactivateAll();
   canvas.renderAll();
   canvas.isDrawingMode = true;
   canvas.freeDrawingBrush = new fabric.PencilBrush(canvas);
   canvas.freeDrawingBrush.color = color;
   canvas.freeDrawingBrush.width = Constants.annotation.strokeWidth * canvas.strokeScale;
   canvas.on('object:added', addedDrawing);
};

const endDrawing = (canvas: any): void => {
   canvas.isDrawingMode = false;
   canvas.off('object:added', addedDrawing);
};

export default {
   startDrawing,
   endDrawing
};